/**
 * Tehran Lesson Audio URL Mapper
 * Maps Persian vocabulary words to their corresponding audio URLs
 */

// Audio URL mapping for Tehran lesson 68749a870819400c3be14af5
const TEHRAN_LESSON_AUDIO_URLS: Record<string, string> = {
  "تهران": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/tehran.mp3",
  "پایتخت": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/capital.mp3",
  "برج آزادی": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/azadi-tower.mp3",
  "بازار بزرگ": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/grand-bazaar.mp3",
  "کاخ گلستان": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/golestan-palace.mp3",
  "معماری": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/architecture.mp3",
  "فرش": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/carpet.mp3",
  "دست‌باف": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/handwoven.mp3",
  "کباب": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/kebab.mp3",
  "برنج": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/rice.mp3",
  "تاریخ": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/history.mp3",
  "فرهنگ": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/culture.mp3",
  "شب": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/night.mp3",
  "پارک": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/park.mp3",
  "شادی": "/audio/68749a870819400c3be14ad4/tehran-cultural-exploration/wordbank/joy.mp3"
};

/**
 * Get the correct audio URL for a Persian vocabulary word in the Tehran lesson
 * @param farsiText - The Persian text
 * @returns The audio URL if found, otherwise null
 */
export function getTehranLessonAudioUrl(farsiText: string): string | null {
  return TEHRAN_LESSON_AUDIO_URLS[farsiText] || null;
}

/**
 * Update vocabulary items with correct audio URLs
 * @param vocabulary - Array of vocabulary items
 * @returns Updated vocabulary items with audio URLs
 */
export function updateTehranLessonVocabularyAudioUrls(vocabulary: Array<{
  farsi: string;
  english: string;
  transliteration: string;
  audio?: string;
}>): Array<{
  farsi: string;
  english: string;
  transliteration: string;
  audio?: string;
}> {
  return vocabulary.map(item => ({
    ...item,
    audio: getTehranLessonAudioUrl(item.farsi) || item.audio
  }));
}

/**
 * Check if an audio URL exists for a Persian word
 * @param farsiText - The Persian text
 * @returns True if audio URL exists
 */
export function hasTehranLessonAudio(farsiText: string): boolean {
  return farsiText in TEHRAN_LESSON_AUDIO_URLS;
}
